//------------------------------------------------------------------------------
// BFA10109G 共架申込 内容確認
//------------------------------------------------------------------------------
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';

import withRouter from '@/components/organisms/withRouter';
import AppLayout from '@/layouts/app-layout';
import PageTitle from '@/components/molecules/PageTitle';
import MessageArea from '@/components/molecules/WarningMessageArea';
import CustomStepper from '@/components/molecules/Stepper';
import commonOperations from '@/reducks/common/operations';
import backend from '@/common/backend';
import TitledArea from '@/components/titled-area';
import PoleItem from '@/utils/pole-item';
import OrderNumber from '@/pages/bfa/common/order-number';
import { LabelValueList } from '@/pages/bfa/common/order-info';
import ConfirmPanel from './confirm-panel';

// 定数
const PAGE_NAME = '共架申込 内容確認';

/**
 * 共架申込 内容確認
 */
class OrderConfirm extends React.Component {
  /**
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.state = {
      warnings: [],      // 警告メッセージ
      orderInfo: {},     // 申込情報
    };
  }

  /**
   * マウント
   */
  async componentDidMount() {

    // 申込番号 (パスパラメーター)
    const orderNo = OrderNumber.from(this.props.params);

    // 申込取得
    const res = await backend.get('/bfa10109g/load/' + orderNo.path());
    const body = res.parse(this.props.doShowMessage).body;
    this.setState({
      orderInfo:  body.orderInfo,
      attachList: body.attachList ?? [],
    });
  }

  /**
   * 描画
   */
  render() {
    const orderNo = OrderNumber.from(this.props.params);
    const orderInfo = this.state.orderInfo;
    const orderPole = new PoleItem({
      areaCode: orderInfo?.kojiAreaCode,
      areaName: orderInfo?.kojiAreaName,
      lineCode: orderInfo?.kojiLineCode,
      lineName: orderInfo?.kojiLineName,
      poleNo:   orderInfo?.kojiPoleNo,
    });
    const { genericMap } = this.props;

    // 一時保存日
    const saveDate = orderInfo?.updateTime
        ?.substring(0, 10)
        ?.replaceAll('-', '/') || ''

    // 描画
    return (
      <AppLayout>

        {/* ページタイトル */}
        <PageTitle pageTitle={PAGE_NAME} />

        {/* メッセージ領域 */}
        <MessageArea messages={this.state.warnings}/>

        {/* 申込進捗 */}
        <Box sx={{ mt: 1 }}>
          <CustomStepper
            category="1"
            status={orderInfo?.orderStatus}
            genericStatus={genericMap?.order_status ?? []}
          />
        </Box>

        {/* 申込情報 */}
        <Grid container direction="row" sx={{ mt: 2, px: 2 }}>
          <TitledArea title="申込情報" sx={{ px: 1, width: '28rem' }}>
            <LabelValueList valueWidth="15rem"
              dataList={[
                { label: '申込番号',     value: orderNo?.toString() },
                { label: '申込日',       value: orderInfo?.orderDate },
                { label: '一時保存日',   value: saveDate },
                { label: '共架事業者',   value: orderInfo?.zigyosyaName },
                { label: '共架申込番号', value: orderInfo?.kgOrderNo },
                { label: '工事件名',     value: orderInfo?.kojiKenmei },
              ]}
            />
          </TitledArea>

          {/* 工事場所 */}
          <TitledArea title="工事場所" sx={{ px: 1, width: '28rem' }}>
            <LabelValueList valueWidth="15rem"
              dataList={[
                { label: '代表電柱', value: orderPole.fullText() },
                { label: '都道府県', value: orderInfo?.kojiTodofuken },
                { label: '市区町村', value: orderInfo?.kojiSikutyoson },
                { label: '大字通称', value: orderInfo?.kojiOazatusyo },
                { label: '字丁目',   value: orderInfo?.kojiAzatyome },
                { label: 'ビル名等', value: orderInfo?.kojiBirumei },
              ]}
            />
          </TitledArea>

          {/* 添付ファイル */}
          <TitledArea title="添付ファイル" sx={{ px: 1, width: '28rem' }}>
            <LabelValueList valueWidth="15rem"
              dataList={[
                { label: 'ルート図',       value: '' },
                { label: '共架設備仕様書', value: '' },
                { label: 'その他資料',     value: '' },
              ]}
            />
          </TitledArea>

            {/* メモ内容 */}
            <TitledArea title="メモ内容" sx={{ px: 1, width: '28rem' }}>
            <TextField
              multiline fullWidth
              defaultValue={orderInfo?.memoRan}
              inputProps={{
                readOnly: true,
                style: {
                  height: '8.5rem',
                  background: 'white'
                },
              }}
            />
          </TitledArea>
        </Grid>

        {/* 操作パネル */}
        <ConfirmPanel
          orderNo={orderNo}
          navigate={this.props.navigate}
        />
      </AppLayout>
    );
  }
}

// プロパティ
OrderConfirm.propTypes = {
  // ルーター
  params: PropTypes.object.isRequired,
  navigate: PropTypes.func.isRequired,

  // ストア
  genericMap: PropTypes.object.isRequired,
  doShowMessage: PropTypes.func.isRequired,
};

// ルーティング
OrderConfirm = withRouter(OrderConfirm);

// ストア接続
const mapStateToProps = (state) => ({
  genericMap: state.master.genericMap,
});
const mapDispatchToProps = {
  doShowMessage: commonOperations.doShowMessage,
};
OrderConfirm = connect(
  mapStateToProps,
  mapDispatchToProps,
)(OrderConfirm);

// エクスポート
export default OrderConfirm;
